import { render, staticRenderFns } from "./PartnershipActivityMailList.vue?vue&type=template&id=1554cda8&"
import script from "./PartnershipActivityMailList.vue?vue&type=script&lang=js&"
export * from "./PartnershipActivityMailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports